export const FEATURE_NAMESPACE = 'widget.operator-view-chart'
